module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"addSymptom":"სიმპტომის დამატება","searchSymptoms":"სიმპტომის ძიება","initial":"საწყისი ჩივილები","present":"ფიქსირდება","absent":"არ ფიქსირდება","featured":"მნიშვნელოვანი"},"en":{"addSymptom":"Add Evindence","searchSymptoms":"Search Evidence","initial":"Inital Symptoms","present":"Present","absent":"Absent","featured":"Featured"}}')
  delete Component.options._Ctor
}
